import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthorizePaymentService } from '../../services/api/authorize-payment.service';
import { EditCreditCard, EditCreditCardResponse, NotifyCreditCardEditRequest, NotifyCreditCardEditResponse,
        getEditTokenPage,  getEditTokenPageResponse, NotifyTokenEditRequest, NotifyTokenEditResponse} from 'src/app/shared/models/authorizeNet.model'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription, filter } from 'rxjs';
import { environment } from 'src/environments/environment'; // Import environment
import { SessionService } from 'src/app/shared/services/session.service';
import { UserService } from 'src/app/shared/services/user.service';
import { ApiEndpoints } from 'src/config/api-endpoints';

declare global {
  interface Window {
    AuthorizeNetIFrame?: any;
  }
}

@Component({
  selector: 'app-hosted-payment-edit',
  templateUrl: './hosted-payment-edit.component.html',
  styleUrls: ['./hosted-payment-edit.component.scss']
})
export class HostedPaymentEditComponent implements OnInit, OnDestroy {

  loading: boolean = false;
  systemError: boolean = false;
  editCreditCardForm: SafeHtml | null = null;
  private apiSubscription: Subscription | undefined;

  @ViewChild('editPaymentIframe') editPaymentIframe: ElementRef | undefined;
  @ViewChild('sendTokenForm') sendTokenForm: ElementRef<HTMLFormElement> | undefined;
  @ViewChild('tokenInput') tokenInput: ElementRef<HTMLInputElement> | undefined;
  @ViewChild('paymentProfileIdInput') paymentProfileIdInput: ElementRef<HTMLInputElement> | undefined;
  @ViewChild('communicatorUrlInput') communicatorUrlInput: ElementRef<HTMLInputElement> | undefined;

  private communicatorUrl: string = `${environment.walletAPPUrl}/assets/web/hostedPaymentIFrameCommunicatorUrl.html`;

  // --- CRITICAL FIX: userId hardcoded, userCreditCardID from route ---

     private userId = sessionStorage.getItem('PPIUserID');
   private customerId = sessionStorage.getItem('PPICustomerID');
  userCreditCardID: string = ''; // Will be populated from route params
  // --- END CRITICAL FIX ---

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authorizepayment: AuthorizePaymentService,
    private sanitizer: DomSanitizer,
    private coreSessionService: SessionService,
    private userService: UserService
  ) { }

  ngOnInit() {
       this.loading = true;
        this.userId = this.userId;
    this.customerId = this.customerId;

    console.log('HostedPaymentEditComponent initialized with userId:', this.userId, 'and customerId:', this.customerId);
        this.setupAuthorizeNetIFrameCommunication();
    // Get userCreditCardID from route parameters
    this.route.paramMap.subscribe(params => {
        const cardId = params.get('cardId'); // 'cardId' must match the route parameter name
        if (cardId) {
            this.userCreditCardID = cardId;
            console.log('HostedPaymentEditComponent: Using userId:', this.userId, 'and userCreditCardID from route:', this.userCreditCardID);
            this.loadHostedPaymentEditForm(); // Load form with dynamic values
        } else {
            console.error('userCreditCardID is missing from route parameters. Cannot load edit form.');
            this.systemError = true;
        }
    });
  }

  ngOnDestroy() {
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
  }

  loadHostedPaymentEditForm() {
    this.loading = true;
    const userId = this.userId;
    const sessionId = sessionStorage.getItem('SessionID');
    const walletID = JSON.parse(sessionStorage.getItem('WalletID') || 'null');
    const userCreditCardID: string = '';

    console.log('HostedPaymentEditComponent: Sending getEditTokenPageRequest payload:');
    console.log('  userid:', this.userId);
    console.log('  walletID:', walletID);
    console.log('  userCreditCardID:', this.userCreditCardID);
    console.log('  sessionID:', sessionId);

    const getEditTokenPageRequest: getEditTokenPage = {
        userCreditCardID: this.userCreditCardID,
        walletID: walletID || '',
        sessionID: sessionId || '',
        userid: this.userId
    };
        this.apiSubscription = this.authorizepayment.getEditTokenPage(getEditTokenPageRequest).subscribe(
      (response: getEditTokenPageResponse) => {
        this.loading = false;
        if (response.success  && response.data?.editForm) {
          const formToken = response.data.editForm.match(/value='([^']*)'/)?.[1];
          const paymentProfileId = response.data.editForm.match(/name="paymentProfileId" value='([^']*)'/)?.[1];

          if (formToken && paymentProfileId) {
            this.loadIframeWithEditForm(formToken, paymentProfileId);
          } else {
            console.error('Form token or paymentProfileId not found in edit response.');
            this.systemError = true;
          }
        } else {
          console.error('Failed to load edit credit card form:', response.message);
          this.systemError = true;
        }
      },
      (error) => {
        this.loading = false;
        console.error('Error calling getEditTokenPage  API:', error);
        this.systemError = true;
      }
    );

  }

  private loadIframeWithEditForm(formToken: string, paymentProfileId: string) {
    if (this.sendTokenForm && this.tokenInput && this.paymentProfileIdInput && this.communicatorUrlInput && this.editPaymentIframe) {
      this.sendTokenForm.nativeElement.action = ApiEndpoints.authorizeneteditpayment; // Edit URL
      this.sendTokenForm.nativeElement.target = 'authorizeNetIframe';

      this.tokenInput.nativeElement.value = formToken;
      this.paymentProfileIdInput.nativeElement.value = paymentProfileId;
      this.communicatorUrlInput.nativeElement.value = this.communicatorUrl;

      // Make iframe visible before submission
      this.editPaymentIframe.nativeElement.style.visibility = 'visible';

      this.sendTokenForm.nativeElement.submit();
      console.log('Edit form submitted to Authorize.Net.');
    } else {
      console.error('Edit form or input elements not found for submission.');
      this.systemError = true;
    }
  }

 // --- NEW: Centralized AuthorizeNetIFrame.onReceiveCommunication handler for EDIT ---
  private setupAuthorizeNetIFrameCommunication(): void {
    const component = this;
    // Check if the handler already exists from the hosted-payment page
    // if (window.AuthorizeNetIFrame && typeof window.AuthorizeNetIFrame.onReceiveCommunication === 'function') {
    //     console.warn('AuthorizeNetIFrame.onReceiveCommunication handler is already defined. Skipping setup.');
    //     return;
    // }

 //   window.AuthorizeNetIFrame = window.AuthorizeNetIFrame || {};

    window.AuthorizeNetIFrame=  {
      onReceiveCommunication: (querystr: string) => {
        const params = component.parseQueryString(querystr);
        switch (params["action"]) {
            case "successfulSave":
                console.log("Credit card edit saved successfully");
                // --- CRITICAL FIX: Call DWNotifyCreditCardEdit API here ---
                const notifyEditRequest: NotifyTokenEditRequest = {
                    walletID: sessionStorage.getItem('WalletID') || '',
                    sessionID: sessionStorage.getItem('SessionID') || '',
                    userID: component.userId,
                    userCreditCardID: component.userCreditCardID,
                };

                 window.top.location.href = '/preferences/manage-payment';
            console.log("This is being called : window top location href");

                component.authorizepayment.notifyTokenEdit(notifyEditRequest).subscribe({
                    next: (response: NotifyTokenEditResponse) => {
                        if (response.success) {
                            console.log('DWNotifyTokenEdit API call successful:', response);
                            // Navigate back to manage-payment after successful notification
                             window.top.location.href = '/preferences/manage-payment';
                           // component.router.navigate(['/preferences/manage-payment']);
                        } else {
                            console.error('DWNotifyTokenEdit API call failed:', response.message);
                            component.systemError = true;
                        }
                    },
                    error: (err) => {
                        console.error('Error calling DWNotifyTokenEdit API:', err);
                        component.systemError = true;
                    }
                });
                break;
            case "cancel":
                console.log("Payment edit process cancelled");
                window.top.location.href = '/preferences/manage-payment';
                // component.router.navigate(['/preferences/manage-payment']);
                break;
            case "resizeWindow":
                const w = parseInt(params["width"]);
                const h = parseInt(params["height"]);
                if (window.document.getElementById("add_payment")) {
                    const ifrm = window.document.getElementById("add_payment") as HTMLIFrameElement;
                    ifrm.style.width = w.toString() + "px";
                    ifrm.style.height = h.toString() + "px";
                }
                break;
            case "transactResponse":
                console.log("Transaction response:", params);
                if (window.document.getElementById("add_payment")) {
                    const ifrm = window.document.getElementById("add_payment") as HTMLIFrameElement;
                    ifrm.style.display = 'none';
                }
                break;
            default:
                console.log("Unknown action:", params["action"]);
        }
      }
    };
  }

  private parseQueryString(str: string): { [key: string]: string } {
    const vars: { [key: string]: string } = {};
    const arr = str.split('&');
    for (let i = 0; i < arr.length; i++) {
        const pair = arr[i].split('=');
        vars[pair[0]] = decodeURIComponent(pair[1]);
    }
    return vars;
  }



}
